import Login from './../login/Login'
import HomeAdmin from './../administration/home/Home';
import HomeCliente from './../cliente/home/home';
import Empresa from '../administration/empresa/Empresa';
import EmpresaConfig from '../administration/empresaConfig/EmpresaConfig';
import DocumentoEnviado from '../cliente/documentos/DocumentoEnviado';
import NominaEnvio from '../cliente/nomina/NominaEnvio';
import Plan from '../administration/plan/Plan';
import RadianIndex from '../cliente/radian/RadianIndex';
import RadianIndexV2 from '../cliente/radian/RadianIndexV2';
import RadianCorreoIndex from '../cliente/radian/RadianCorreoIndex';
import EmisionInstancia from '../administration/reporte/EmisionInstancia';
import EmisionPlan from '../administration/reporte/EmisionPlan';
import EmisionTiempo from '../administration/reporte/EmisionTiempo';
import RegistroNuevo from './../registro/RegistroNuevo'
import {
    Routes,
    Route
} from "react-router-dom";
import Certificates from '../administration/reporte/Certificados';
import { ProtectedRoute, PermissionRoute, LayoutNotMenu } from './ProtectedRoute';
import Usuarios from './../administration/seguridad/Usuarios';
import Roles from './../administration/seguridad/Roles';
import Auditoria from './../administration/seguridad/Auditoria';
import EmisionGeneral from '../administration/reporte/EmisionGeneral';
import PlantillasCorreos from '../administration/configuracion/PlantillasCorreos';
import Smtp from '../administration/configuracion/Smtp';
import GestionarClave from '../login/GestionarClave';
import BandejaEnviados from '../administration/configuracion/BandejaEnviados';
import EmisionDashboard from '../administration/reporte/EmisionDashboard';
import ConfirmaBaja from '../administration/seguridad/ConfirmaBaja';
import Factura from '../administration/transacciones/factura/Factura';
import FacturaCRUD from '../administration/transacciones/factura/FacturaCRUD';
import Cartera from '../administration/transacciones/cartera/Cartera';
import Recibos from '../administration/transacciones/recibos/Recibos';
import ClientesPendientes from '../administration/transacciones/cartera/ClientesPendientes';
import EmisionDocumentos from '../cliente/reporte/EmisionDocumentos';
import EmisionPrefijos from '../cliente/reporte/EmisionPrefijos';
import EmisionGeneralExcel from '../cliente/reporte/EmisionGeneral';
import Producto from '../administration/transacciones/productos/Producto';
import ProyeccionVentas from '../administration/reporte/ProyeccionVentas';
import Soporte from '../cliente/soporte/Soporte';
import SoporteCRUD from '../cliente/soporte/SoporteCRUD';
import AutoGestion from '../administration/transacciones/autogestion/AutoGestion';
import GestionClientes from '../administration/transacciones/autogestion/GestionClientes';
import { useSelector } from 'react-redux';
import ClientesVinculados from '../administration/transacciones/cartera/ClientesVinculados';
import Novedad from '../administration/transacciones/novedades/Novedad';
import NovedadCrud from '../administration/transacciones/novedades/NovedadCrud';
import NovedadVisualiza from '../cliente/novedades/NovedadVisualiza';

function RoutesTae(props) {
    ///Obtenemos el estado de si es admin o no
    const adminTae = useSelector((state) => state.auth.AdminTae);

    return (<Routes>

        <Route element={<LayoutNotMenu />}>


            <Route path="/" element={<Login />} />
            <Route path="/Login" element={<Login />} />
            <Route path='/RegistroNuevo' element={<RegistroNuevo />} />
            <Route path='/Login/GestionarClave/:id' element={<GestionarClave />} />
            <Route path='/Seguridad/ConfirmaBaja/:x' element={<ConfirmaBaja />} />
            <Route
                index={true}
                element={<Login />}
            />
            {props.Autenticado === true ? <>
                {/* <Route path="/Home/Empresa/Config/:CompanyId" element={<EmpresaConfig />} /> */}

                {/* Rutas privadas / Solamente tiene acceso el usuario admin de TAE
                ProtectedRoute --> Valida primeramente si el usuario que ingreso es admin o no
                PermissionRoute --> Valida si el usuario el cual ingreso tiene permisos para ese modulo
            */}
                <Route element={
                    <ProtectedRoute isAllowed={(adminTae === 'true' ? true : false)} redirectPath='/home' />
                }>
                    <Route path="/Home/Empresa" element={
                        <PermissionRoute permiso={["GestionEmpresa"]}>
                            <Empresa />
                        </PermissionRoute>
                    } />

                    <Route path="/Home/Plan" element={
                        <PermissionRoute permiso={["GestionModPlanes"]}>
                            <Plan />
                        </PermissionRoute>
                    } />

                    <Route path='/Home/Reporte/EmisionInstancia' element={
                        <PermissionRoute permiso={["GestionReportes", "GestionRepIns"]}>
                            <EmisionInstancia />
                        </PermissionRoute>
                    } />
                    <Route path='/Home/Reporte/Certificados' element={
                        <PermissionRoute permiso={["GestionReportes", "GestionRepCer"]}>
                            <Certificates />
                        </PermissionRoute>
                    } />
                    <Route path='/Home/Reporte/EmisionPlan' element={
                        <PermissionRoute permiso={["GestionReportes", "GestionRepPla"]}>
                            <EmisionPlan />
                        </PermissionRoute>
                    } />
                    <Route path='/Home/Reporte/EmisionTiempo' element={
                        <PermissionRoute permiso={["GestionReportes", "GestionRepTiem"]}>
                            <EmisionTiempo />
                        </PermissionRoute>
                    } />

                    <Route path='/Home/Reporte/EmisionesGeneral' element={
                        <PermissionRoute permiso={["GestionReportes", "GestionRepEmis"]}>
                            <EmisionGeneral />
                        </PermissionRoute>
                    } />

                    <Route path='/Home/Reporte/ProyeccionVentas' element={
                        <PermissionRoute permiso={["GestionReportes", "GestionRepProye"]}>
                            <ProyeccionVentas />
                        </PermissionRoute>
                    } />

                    <Route path='/Home/Reporte/EmisionDashboard' element={
                        <EmisionDashboard />
                    } />

                    <Route path='/Configuracion/PlantillasCorreos' element={
                        <PermissionRoute permiso={["GestionConfig", "GestionPlantilla"]}>
                            <PlantillasCorreos />
                        </PermissionRoute>
                    } />

                    <Route path='/Configuracion/Smtp' element={
                        <PermissionRoute permiso={["GestionConfig", "GestionSMTP"]}>
                            <Smtp />
                        </PermissionRoute>
                    } />

                    <Route path='/Configuracion/BandejaEnviados' element={
                        <PermissionRoute permiso={["GestionConfig", "GestionBandejaEnviado"]}>
                            <BandejaEnviados />
                        </PermissionRoute>
                    } />

                    <Route path='/Home/Factura' element={
                        <PermissionRoute permiso={["GestionModuloTrans"]}>
                            <Factura />
                        </PermissionRoute>
                    } />

                    <Route path='/Home/Cartera' element={
                        <PermissionRoute permiso={["GestionModuloTrans"]}>
                            <Cartera />
                        </PermissionRoute>
                    } />

                    <Route path='/Home/Recibos' element={
                        <PermissionRoute permiso={["GestionModuloTrans"]}>
                            <Recibos />
                        </PermissionRoute>
                    } />


                    <Route path='/Home/ReportePendientes' element={
                        <PermissionRoute permiso={["GestionModuloTrans"]}>
                            <ClientesPendientes />
                        </PermissionRoute>
                    } />

                    <Route path='/Home/ReporteClientesVinculados' element={
                        <PermissionRoute permiso={["GestionModuloTrans"]}>
                            <ClientesVinculados />
                        </PermissionRoute>
                    } />
                </Route>

                {/* Rutas publicas / Cualquiera puede ingresar */}
                <Route path="/Home" element={<HomeAdmin />} />
                <Route path="/Home/Cliente" element={<HomeCliente />} />

                <Route path="/Home/Empresa/Config/:CompanyId" element={
                    <PermissionRoute permiso={["GestionEmpresa"]}>
                        <EmpresaConfig />
                    </PermissionRoute>
                } />

                <Route path='/Seguridad/Usuarios' element={
                    <PermissionRoute permiso={["GestionSeguridad", "SeguridadUsuarios"]}>
                        <Usuarios />
                    </PermissionRoute>
                } />

                <Route path='/Seguridad/Roles' element={
                    <PermissionRoute permiso={["GestionSeguridad", "SeguridadRoles"]}>
                        <Roles />
                    </PermissionRoute>
                } />

                <Route path='/Seguridad/Auditoria' element={
                    <PermissionRoute permiso={["GestionSeguridad", "SeguridadAuditoria"]}>
                        <Auditoria />
                    </PermissionRoute>
                } />


                <Route path='/Cliente/ReporteEmisionDocumentos' element={
                    <PermissionRoute permiso={["GestionReporCliente"]}>
                        <EmisionDocumentos />
                    </PermissionRoute>
                } />

                <Route path='/Cliente/ReporteEmisionPrefijos' element={
                    <PermissionRoute permiso={["GestionReporCliente"]}>
                        <EmisionPrefijos />
                    </PermissionRoute>
                } />

                <Route path='/Cliente/ReporteEmisionGeneralExcel' element={
                    <PermissionRoute permiso={["GestionReporCliente"]}>
                        <EmisionGeneralExcel />
                    </PermissionRoute>
                } />

                <Route path='/Home/Productos' element={
                    <PermissionRoute permiso={["GestionModuloTrans"]}>
                        <Producto />
                    </PermissionRoute>
                } />

                <Route path='/Home/FacturaCRUD/:id' element={
                    <FacturaCRUD />
                } />

                <Route path='/Home/Pqr' element={
                    <Soporte />
                } />

                <Route path='/Home/PqrCRUD/:id' element={
                    <SoporteCRUD />
                } />

                <Route path='/Home/AutoGestion' element={
                    <AutoGestion />
                } />

                <Route path='/Home/GestionClientes' element={
                    <GestionClientes />
                } />

                <Route path='/Cliente/NovedadVisualiza' element={
                    <NovedadVisualiza />
                } />

                {adminTae === 'true' ?
                    <>
                        <Route path='/Cliente/DocumentoEnvio' element={
                            <PermissionRoute permiso={["GestionEnvios", "GestionEnvFac"]}>
                                <DocumentoEnviado />
                            </PermissionRoute>
                        } />
                        <Route path='/Cliente/NominaEnvio' element={
                            <PermissionRoute permiso={["GestionEnvios", "GestionEnvNom"]}>
                                <NominaEnvio />
                            </PermissionRoute>
                        } />
                        <Route path='/Cliente/RadianIndex' element={
                            <PermissionRoute permiso={["GestionRadian"]}>
                                <RadianIndex />
                            </PermissionRoute>
                        } />
                        <Route path='/Cliente/RadianCorreoIndex' element={
                            <PermissionRoute permiso={["GestionRadian"]}>
                                <RadianCorreoIndex />
                            </PermissionRoute>
                        } />
                        <Route path='/Cliente/RadianIndexV2' element={
                            <RadianIndexV2 />
                        } />
                        <Route path='/Home/Novedades' element={
                            <Novedad />
                        } />
                        <Route path='/Home/NovedadesCrud/:id' element={
                            <NovedadCrud />
                        } />
                    </>
                    :
                    <>
                        <Route path='/Cliente/DocumentoEnvio' element={<DocumentoEnviado />} />
                        <Route path='/Cliente/NominaEnvio' element={<NominaEnvio />} />
                        <Route path='/Cliente/RadianIndex' element={<RadianIndex />} />
                        <Route path='/Cliente/RadianCorreoIndex' element={<RadianCorreoIndex />} />
                        <Route path='/Cliente/RadianIndexV2' element={<RadianIndexV2 />} />
                        <Route path='/Cliente/NovedadVisualiza' element={<NovedadVisualiza />} />
                    </>
                }
            </> : null}

        </Route>
    </Routes>);

}


export default RoutesTae;